import styles from '@/pages/backend/cardCampSettings/nodeSettings/index.less';
import { Modal, Result, Space } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { useRequest } from '@@/plugin-request/request';
import { deleteNodeById, getCampNodes, sortNodeList } from '@/services/ConsoleRequest';
import { useParams } from 'umi';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import DragList from '@/pages/backend/cardCampSettings/nodeSettings/DragList';
import cx from 'classnames';

type TNodeListProps = {
  activeId?: string;
  onIndexChange: (index: number) => void;
  onNameChange: (names: { id: string; name: string }[]) => void;
  onClick: (id: string | undefined, index: number, name: string) => void;
};

type TNodeListNodeProps = {
  id: string;
  name: string;
};

const NodeList = forwardRef<any, TNodeListProps>((props, ref) => {
  const { onNameChange, activeId, onClick, onIndexChange } = props;
  const [newNodeCount, setNewNodeCount] = useState(0);
  const [dataSource, setDataSource] = useState<TNodeListNodeProps[]>([]);
  const { id: campId } = useParams<{ id: string }>();
  const { loading, run } = useRequest(
    () => {
      return getCampNodes(campId);
    },
    {
      onSuccess: (res) => {
        if (Array.isArray(res)) {
          setDataSource(res);
          onNameChange(res.map((item) => ({ name: item.name, id: item.id })));
        } else {
          setDataSource([]);
        }
      },
    },
  );
  useEffect(() => {
    // 进入页面自动选中第一个
    if (Array.isArray(dataSource) && dataSource.length > 0) {
      if (!activeId) {
        onClick(dataSource[0].id, 0, dataSource[0].name);
      }
    } else {
      onClick(undefined, 0, '');
    }
  }, [dataSource]);

  useImperativeHandle(ref, () => {
    return {
      reload: () => {
        run();
      },
    };
  });
  return (
    <div className={styles.node_settings_left}>
      <div className={styles.node_settings_left_header}>
        <div className={styles.node_settings_left_header_title}>打卡节点</div>
        <Space
          className="text-blue cursor-pointer"
          onClick={() => {
            const createNewNode = () => {
              const newId = `newId${String(Date.now())}`;
              const name = `未命名节点${newNodeCount}`;
              setDataSource((prevState) => {
                prevState.push({ id: newId, name });
                setNewNodeCount(newNodeCount + 1);
                return [...prevState];
              });
              setTimeout(() => {
                onClick?.(newId, dataSource.length - 1, name);
                const nodeDom = document.getElementById(newId);
                if (nodeDom) {
                  nodeDom.scrollIntoView();
                }
              }, 200);
            };
            console.log('此时的activeId是', activeId);
            if (activeId && activeId?.startsWith('newId')) {
              //  当前节点是新节点并且点击了按钮试图创建另一个新节点时给提示
              Modal.confirm({
                title: '当前节点内容未保存',
                icon: <ExclamationCircleOutlined />,
                content: '离开此节点将丢失该节点的内容',
                okText: '离开',
                cancelText: '关闭',
                onOk: () => {
                  createNewNode();
                },
              });
            } else {
              createNewNode();
            }
          }}
        >
          <PlusSquareOutlined />
          新建节点
        </Space>
      </div>
      <div className={styles.node_settings_left_body}>
        <DragList<TNodeListNodeProps>
          data={dataSource}
          extraParams={{ activeId }}
          onDragEnd={async (data, extraParams) => {
            console.log('onDragEnd触发');
            console.log(data);
            await sortNodeList(data);
            const idx = data.findIndex((item) => item.id === extraParams.activeId);
            if (idx > -1) {
              onIndexChange(idx);
            }
          }}
          emptyComponent={() => {
            return (
              <Result
                subTitle={<div>暂无打卡节点</div>}
                icon={<img src={'https://hwobs.fanruan.com/ui/question.png'} width={180} />}
              />
            );
          }}
          component={(item, index) => (
            <div
              className={cx(styles.item, activeId === item.id && styles.active)}
              onClick={() => {
                if (activeId?.startsWith('newId')) {
                  Modal.confirm({
                    title: '当前节点内容未保存',
                    icon: <ExclamationCircleOutlined />,
                    content: '离开此节点将丢失该节点的内容',
                    okText: '离开',
                    cancelText: '关闭',
                    onOk: () => {
                      onClick(item.id, index, item.name);
                    },
                  });
                } else {
                  onClick(item.id, index, item.name);
                }
              }}
            >
              <div className="truncate max-w-[150px]">{item.name}</div>
              <div className={styles.delete_icon}>
                <DeleteOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    Modal.confirm({
                      okType: 'danger',
                      title: `确认删除【${item.name}】？`,
                      content: '删除节点后将影响当前进行中和后续批次，历史已结束的批次将不受影响。',
                      okText: '删除',
                      onOk: async () => {
                        // 以newId开头的 直接从列表数据里删除 不用走接口
                        if (item.id.startsWith('newId')) {
                          const idx = dataSource.findIndex(
                            (dataSourceItem) => dataSourceItem.id === item.id,
                          );
                          if (idx > -1) {
                            setDataSource((prevState) => {
                              prevState.splice(idx, 1);
                              return [...prevState];
                            });
                          }
                        } else {
                          await deleteNodeById(item.id);
                          await run();
                        }
                      },
                    });
                  }}
                />
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
});
export default NodeList;
